import { Slider, ConfigProvider } from "antd";

const MySlide = ({ min, max, value, ...rest }) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Slider: {
            colorPrimary: "#FF6B38",
            colorPrimaryActive: "#FF6B38",
            colorPrimaryBorder: "#FF6B38",
            colorPrimaryHover: "#FF6B38",
            colorPrimaryBorderHover: "#FF6B38",
          },
        },
      }}
    >
      <Slider {...rest} />
    </ConfigProvider>
  );
};

export default MySlide;
